import SchoolNotFound from './SchoolNotFound'

export default SchoolNotFound
